// extracted by mini-css-extract-plugin
export default {"xs":"319px","sm":"575px","md":"767px","lg":"1199px","xl":"1919px"};